import { render, staticRenderFns } from "./PowerRankingsView.vue?vue&type=template&id=a5b0365e&"
import script from "./PowerRankingsView.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports